module.exports = __webpack_public_path__ + "static/media/waterfall_chart.8590fcc9.svg";